import React from 'react';
import styled, { css } from 'styled-components';
import HelpButton from '~/components/molecule/HelpButton';
import JustificationContainer from '~/components/atom/JustificationContainer';
import Link from '~/components/molecule/Link';
import { HELP_DESK_LINK } from '~/constants';

const CsvImportExplanation = () => (
  <JustificationContainer direction="column" align="center">
    Upload een csv bestand om meerdere contacten te importeren.
    <div>
      Maak gebruik van dit{' '}
      <Link to="https://dhstash.s3-eu-west-1.amazonaws.com/importContacts.xlsx">
        Excel template
      </Link>{' '}
      en sla deze als csv bestand op
      <StyledHelpButton
        link={{
          link: `${HELP_DESK_LINK}/nl/articles/4003756-hoe-importeer-ik-contacten`,
        }}
      />
    </div>
  </JustificationContainer>
);

const StyledHelpButton = styled(HelpButton)(
  ({ theme }) => css`
    margin-left: ${theme.space('xxs')};
  `,
);

export default CsvImportExplanation;
